export const MODE_SUMMARY = 'mode/summary';
export const MODE_MAINTENANCE = 'mode/maintenance';
export const MODE_DOCUMENTATION = 'mode/documentation';

export const NO_SITES_MESSAGE = 'No sites to display';

/*
 * @react-components colors
 * $StatusBlue: [51, 102, 255]
 * $StatusGreen: [12, 169, 25]
 * $StatusOrange: [255, 115, 0]
 * $StatusRed: [240, 48, 64]
 */

export const STATUSES = {
  default: {
    icon: 'empty',
    color: [51, 102, 255],
    colorHex: 0xff7300,
  },
  0: {
    icon: 'he-statushealthy',
    color: [12, 169, 25],
    colorHex: 0x18bc19,
  },
  1: {
    icon: 'he-statusriskhigh',
    color: [255, 115, 0],
    colorHex: 0xff7300,
  },
  2: {
    icon: 'cancel',
    color: [240, 48, 64],
    colorHex: 0xf03040,
  },
  r1: {
    icon: 'he-statusrisklow',
    text: 'Low Risk',
    color: [45, 118, 206],
    colorHex: 0x414141,
  },
  r2: {
    icon: 'he-statusriskmedium',
    text: 'Medium Risk',
    color: [198, 182, 40],
    colorHex: 0xc6b628,
  },
  r3: {
    icon: 'he-statusriskhigh',
    text: 'High Risk',
    color: [198, 40, 40],
    colorHex: 0xc62828,
  },
};

export const SEVERITIES = {
  critical: 'Emergency',
  warning: 'Warning / Severe',
  minor: 'Minor',
  info: 'Normal',
  internal: 'Maintenance / Internal',
};

export const THRESHOLD_TYPES = {
  linear: {
    key: 'linearItems',
    name: 'Linear',
    value: 'linear',
  },
  area: {
    key: 'areaItems',
    name: 'Area',
    value: 'area',
  },
};

export const PAGE_TYPES = {
  stateset: 'Stateset',
  risk: 'Risk',
  health: 'Health',
  none: 'None',
};
export const DEFAULT_PAGETYPE = 'none';

export const DEFAULT_AGGREGATION_OPTIONS = [
  {
    label: 'Avg',
    value: 'avg',
  },
  {
    label: 'Min',
    value: 'min',
  },
  {
    label: 'Max',
    value: 'max',
  },
  {
    label: 'First',
    value: 'first',
  },
  {
    label: 'Last',
    value: 'last',
  },
];

export const GRANULARITY_OPTIONS = [
  {
    label: 'Second',
    value: '1s',
  },
  {
    label: 'Minute',
    value: '60s',
  },
  {
    label: 'Fifteen minutes',
    value: '900s',
  },
  {
    label: 'Thirty minutes',
    value: '1800s',
  },
  {
    label: 'Hour',
    value: '3600s',
  },
  {
    label: 'Day',
    value: '86400s',
  },
  {
    label: 'Week',
    value: '604800s',
  },
  {
    label: 'Month',
    value: '2592000s',
  },
  {
    label: 'Quarter',
    value: '7862400s',
  },
  {
    label: 'Year',
    value: '31536000s',
  },
];

export const EXPORT_TIMESERIES_PROGRESS_LOGIC_EC = {
  // This is the progress prediction logic for EC adapter
  // noOfDatapoints: {noOfSignals: [ProgressIncrement,timeInterval]}
  10000: {
    10: [6, 300],
    50: [5, 500],
    100: [4, 800],
    150: [3, 1100],
    200: [3, 1400],
    default: [6, 1000],
  },
  50000: {
    10: [3, 300],
    50: [2, 500],
    100: [2, 800],
    150: [2, 1100],
    200: [2, 1400],
    default: [3, 1000],
  },
  100000: {
    10: [3, 300],
    50: [2, 500],
    100: [2, 800],
    150: [2, 1100],
    200: [2, 1400],
    default: [3, 1000],
  },
};

export const EXPORT_TIMESERIES_DATA_POINTS_LIMIT_EC = 10000;
export const EXPORT_TIMESERIES_PANEL = 'timeseriesExportPanel';
export const SIGNAL_VIEWER_DATETIME = 'signalviewerdatetime';

export const EXPORT_EVENT_PANEL = 'exportEventPanel';
export const EXPORT_EVENT_LIMIT = 300000;
export const NEW_PANEL = 'ENTER-PANEL-TYPE';
export const PROJECT_DELIVERY_TYPE = {
  MIMS: 'MIMS',
  EC: 'MIMS + Energy Connect',
};
